import * as request from 'requestES';

/**
 * getReserveNum 获取预约信息 是否已经预约看缓存信息
 * doReserve 上传预约信息
 */
export const doReserve = function (action, data) {
  const url = `//geventsapi.37games.com/activity/execute?name=dlssrvtyy&action=${action}`;
  return request.ajax({
    url,
    data,
  });
};
// ip判断地区
export const ipArea = function () {
  return request.ajax({
    // url: '//gstore.37games.com/test_ip',
    url: '//geventsapi.37games.com/activity/execute?name=dlssrvtyy&action=getReserveNum',
  });
};
// 正常请求 basic lottery award_log shareCallback
export const req = function (action, data) {
  const url = `//geventsapi.37games.com/activity/execute?name=dlssrvtyy&action=${action}`;
  return request.ajax({
    url,
    data,
  });
};
